import React from 'react';
import { frames } from '#packages/panels';
const { MessagePanelFrame } = frames;

interface GenericMessageProps {
  panelName: string;
  title: string;
  message: string;
  primaryButton: {
    label: string;
  };
  dataHook: string;
  onConfirm(): void;
  confirmLabel: string;
  close: () => {};
}

const GenericMessage: React.FC<GenericMessageProps> = ({
  title,
  message,
  dataHook,
  confirmLabel,
  onConfirm,
  close,
}) => {
  return (
    <MessagePanelFrame
      panelName={'GenericMessage'}
      title={title}
      confirmLabel={confirmLabel}
      onConfirm={onConfirm}
      dataHook={dataHook}
      onCancel={close}
    >
      {message}
    </MessagePanelFrame>
  );
};

export default GenericMessage;
